module.exports = __webpack_public_path__ + "static/img/slogan.700b312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/slogan.png
// module id = HWHg
// module chunks = 1